import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Facebook, Instagram, Youtube } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_exam-excellence-hub/artifacts/e4f9i88p_trident%20logo.jpeg";

const quickLinks = [
  { name: "Home", path: "/" },
  { name: "About Us", path: "/about" },
  { name: "Courses", path: "/courses" },
  { name: "Faculty", path: "/faculty" },
  { name: "Results", path: "/results" },
  { name: "Contact", path: "/contact" },
];

const courses = [
  { name: "11th Science", path: "/courses" },
  { name: "12th Science", path: "/courses" },
  { name: "NEET Preparation", path: "/courses" },
  { name: "JEE Main & Advanced", path: "/courses" },
  { name: "MHT-CET Preparation", path: "/courses" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" style={{ backgroundColor: "#0A2540" }} className="text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10">

          {/* Brand */}
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img src={LOGO_URL} alt="Trident Academy" className="h-12 w-12 object-contain bg-white rounded-lg p-1" />
              <div>
                <div className="text-white font-bold text-sm tracking-widest" style={{ fontFamily: "Manrope, sans-serif" }}>TRIDENT ACADEMY</div>
                <div className="text-xs tracking-widest" style={{ color: "#F2C94C" }}>WHERE DREAMS MEET REALITY</div>
              </div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed mt-4">
             <b className="text-white">C/O Bharty Tutorials</b> <br/>  Premier science coaching institute in Kandivali East, Mumbai. Guiding students since 2020.
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="https://facebook.com" target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-yellow-400 hover:text-[#0A2540] transition-colors"
                data-testid="footer-facebook"><Facebook size={16} /></a>
              <a href="https://www.instagram.com/thetridentacademy" target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-yellow-400 hover:text-[#0A2540] transition-colors"
                data-testid="footer-instagram"><Instagram size={16} /></a>
              <a href="https://youtube.com" target="_blank" rel="noopener noreferrer"
                className="w-9 h-9 rounded-full bg-white/10 flex items-center justify-center hover:bg-yellow-400 hover:text-[#0A2540] transition-colors"
                data-testid="footer-youtube"><Youtube size={16} /></a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-bold text-sm tracking-wider uppercase mb-5" style={{ fontFamily: "Manrope, sans-serif" }}>Quick Links</h3>
            <ul className="space-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <Link to={link.path} className="text-sm text-gray-400 hover:text-yellow-400 transition-colors flex items-center gap-2 group">
                    <span className="w-1 h-1 rounded-full bg-yellow-400 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                    {link.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Courses */}
          <div>
            <h3 className="text-white font-bold text-sm tracking-wider uppercase mb-5" style={{ fontFamily: "Manrope, sans-serif" }}>Our Courses</h3>
            <ul className="space-y-2.5">
              {courses.map((course) => (
                <li key={course.name}>
                  <Link to={course.path} className="text-sm text-gray-400 hover:text-yellow-400 transition-colors flex items-center gap-2 group">
                    <span className="w-1 h-1 rounded-full bg-yellow-400 opacity-0 group-hover:opacity-100 transition-opacity"></span>
                    {course.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Instagram */}
          <div>
            <h3 className="text-white font-bold text-sm tracking-wider uppercase mb-5" style={{ fontFamily: "Manrope, sans-serif" }}>Follow on Instagram</h3>
            <a href="https://www.instagram.com/thetridentacademy" target="_blank" rel="noopener noreferrer"
              data-testid="footer-instagram-section"
              className="block rounded-xl overflow-hidden border-2 border-white/10 hover:border-pink-400 transition-all group">
              <div className="p-4" style={{ background: "linear-gradient(135deg, #f09433 0%, #e6683c 25%, #dc2743 50%, #cc2366 75%, #bc1888 100%)" }}>
                <Instagram size={28} color="white" className="mx-auto mb-2 block" />
                <p className="text-white text-center text-xs font-bold tracking-wide">@thetridentacademy</p>
              </div>
              <div className="bg-white/5 px-4 py-3 text-center">
                <p className="text-gray-300 text-xs">Follow us for updates, results & more</p>
                <p className="text-pink-400 text-xs font-semibold mt-1 group-hover:underline">View Profile &rarr;</p>
              </div>
            </a>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-white font-bold text-sm tracking-wider uppercase mb-5" style={{ fontFamily: "Manrope, sans-serif" }}>Contact Us</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <MapPin size={16} className="text-yellow-400 flex-shrink-0 mt-0.5" />
                <span className="text-sm text-gray-400 leading-relaxed">Kandivali East, Mumbai, Maharashtra – 400101</span>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-yellow-400 flex-shrink-0" />
                <a href="tel:9867913757" className="text-sm text-gray-400 hover:text-yellow-400 transition-colors">+91 9867913757</a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-yellow-400 flex-shrink-0" />
                <a href="tel:7977526163" className="text-sm text-gray-400 hover:text-yellow-400 transition-colors">+91 7977526163</a>
              </li>
              <li className="flex items-center gap-3">
                <Phone size={16} className="text-yellow-400 flex-shrink-0" />
                <a href="tel:7977678307" className="text-sm text-gray-400 hover:text-yellow-400 transition-colors">+91 7977678307</a>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-yellow-400 flex-shrink-0" />
                <a href="mailto:tridentacademy101@gmail.com" className="text-sm text-gray-400 hover:text-yellow-400 transition-colors">tridentacademy101@gmail.com</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-6 flex flex-col sm:flex-row items-center justify-center sm:justify-between gap-3 text-center sm:text-left">
          <p className="text-sm text-gray-500 text-center">&copy; {new Date().getFullYear()} Trident Academy. All rights reserved.</p>
          <p className="text-sm text-center text-gray-500">
            Website Designed & Developed by <br/> {" "}
            <a
              href="https://triverseinfotech.com"
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-400 hover:underline"
            >
              Triverse Infotech
            </a>
          </p>

          <p className="text-sm text-center text-gray-500">Established 2020 | Kandivali East, Mumbai</p>
        </div>
      </div>
    </footer>
  );
}
